//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { LocalizationHelper } from "../../../../helpers"

import { Enums } from "../../../../models/common"
import { OpDataType } from "../../../../models/core"


export class DataTypeClassTextRule implements IDataTypePanelRule {

    private static get dataTypeClass(): number { return Enums.DataTypeClass.Text }

    //#region IDataTypePanelRule

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return $.Deferred<boolean>()
            .resolve(opDataType != null && opDataType.idDataTypeClass === DataTypeClassTextRule.dataTypeClass)
            .promise()
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any[]): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        if (opDataType != null) {
            const item: IMRDataTypePanelFormItemOptions = {
                dataField: opDataType.idDataType.toString(),
                editorType: 'dxTextBox',
                validationRules: this.getDataTypeRuleOptions(opDataType, isRequired),

                editorOptions: {
                    value: _.first(data)
                },

                label: {
                    location: 'top',
                    text: opDataType.toString()
                },
            }

            return $.Deferred().resolve(item).promise()
        }

        return $.Deferred().resolve(null).promise()
    }

    //#endregion


    //#region Private Methods

    private getDataTypeRuleOptions(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []

        if (opDataType != null && opDataType.dataTypeFormat != null) {

            if (opDataType.dataTypeFormat.textMinLength) {
                validationRules.push({
                    type: 'stringLength',
                    min: opDataType.dataTypeFormat.textMinLength,
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MinNumberOfCharacters) + ' ' + opDataType.dataTypeFormat.textMinLength
                })
            }

            if (opDataType.dataTypeFormat.textMaxLength) {
                validationRules.push({
                    type: 'stringLength',
                    max: opDataType.dataTypeFormat.textMaxLength,
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MaxNumberOfCharacters) + ' ' + opDataType.dataTypeFormat.textMaxLength
                })
            }
        }

        if (isRequired) {
            validationRules.push({
                type: 'required',
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            })
        }

        return validationRules
    }

    //#endregion

}